import { createContext, useContext } from 'react';
import { BdmSubmittedBatchFile } from '../../../types/opm-pd-bdm-types';

type Policy = NonNullable<BdmSubmittedBatchFile['policies']>[number] & {
  _selectedQualifiedAgentName?: string;
  _selectedQualifiedAgent?: string;
  _sentBackFromLabel?: string;
  _policyTaskStatusLabel?: string;
};

export type BatchFilesViewPageContextType = {
  bdmSubmittedBatchFile: BdmSubmittedBatchFile | null;
  bdmSubmittedBatchFileLoading: boolean;
  policies: Policy[];
};

export const BatchFilesViewPageContext = createContext<BatchFilesViewPageContextType>({
  bdmSubmittedBatchFile: null,
  bdmSubmittedBatchFileLoading: false,
  policies: [],
});

export const useBatchFilesViewPageContext = (): BatchFilesViewPageContextType => {
  const context = useContext(BatchFilesViewPageContext);
  if (!context) {
    throw new Error('useBatchFilesViewPageContext must be used within a BatchFilesViewPageContext.Provider');
  }
  return context;
};
